import { Button, Card, Input, Select } from "antd";

import styles from "./index.module.less";
import { Modules, Operations, UserModuleAndIdMapping } from "../../constants/DatabaseConstants/MasterConstant";
import { General } from "../../util/General";
import WebUserList from "./WebUser/WebUserList";
import MobileUserList from "./MobileUser/MobileUserList";
import Authentication from "../../util/Authentication";
import useUserManagement from "./index.hook";
import VisitorUserList from "./VisitorUser";

const UserManagement = () => {
  const config = useUserManagement();

  return (
    <Card className="gx-card card--height" title={null}>
      {/* header filters */}
      <div className={styles["user-master-container"]}>
        <div className={styles["section1"]}>
          <span className="card-title-style">User Management</span>
          <Select getPopupContainer={(trigger) => trigger.parentElement} dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }} className={`${styles["select-master-dropdown"]}`} placeholder="Select Master Name" onChange={config.handleListSelect} value={config.selectedId} showSearch filterOption={General.searchFilterOnSelect}>
            {Authentication.hasModuleAndOperationAccess(config.userData, Modules.WEB_USER, Operations.READ) && <Select.Option value={UserModuleAndIdMapping.WEB_USER}>Web Users</Select.Option>}
            {Authentication.hasModuleAndOperationAccess(config.userData, Modules.MOBILE_USER, Operations.READ) && <Select.Option value={UserModuleAndIdMapping.MOBILE_USER}>Mobile Users</Select.Option>}
            {Authentication.hasModuleAndOperationAccess(config.userData, Modules.MOBILE_USER, Operations.READ) && <Select.Option value={UserModuleAndIdMapping.VISITOR_USER}>Visitor Users</Select.Option>}
          </Select>
        </div>
        <div className={styles["section2"]}>
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} onSearch={config.handleChangeOnSearch} onChange={(e) => config.handleChangeSearch(e.target.value)} value={config.searchedText} />
          {Authentication.hasModuleAndOperationAccess(config.userData, Modules.WEB_USER, Operations.CREATE) && Authentication.hasModuleAndOperationAccess(config.userData, Modules.WEB_USER, Operations.READ) && config.selectedId === UserModuleAndIdMapping.WEB_USER && (
            <Button className={`button-gradiant gx-mb-0 add-button`} onClick={config.handleAddClick}>
              Add User
            </Button>
          )}
        </div>
      </div>

      {/* Display Table component */}
      {Authentication.hasModuleAndOperationAccess(config.userData, Modules.WEB_USER, Operations.READ) && config.selectedId === UserModuleAndIdMapping.WEB_USER && <WebUserList searchedText={config.searchedText} />}
      {Authentication.hasModuleAndOperationAccess(config.userData, Modules.MOBILE_USER, Operations.READ) && config.selectedId === UserModuleAndIdMapping.MOBILE_USER && <MobileUserList searchedText={config.searchedText} />}
      {Authentication.hasModuleAndOperationAccess(config.userData, Modules.MOBILE_USER, Operations.READ) && config.selectedId === UserModuleAndIdMapping.VISITOR_USER && <VisitorUserList searchedText={config.searchedText} />}
    </Card>
  );
};

export default UserManagement;
